import { Row, Col, Card, Button, Tabs, InputNumber, Select, Checkbox, Tooltip, Popconfirm, Tag } from 'antd';
import { FormattedMessage } from 'react-intl';
import { tolerancePlaceholder } from '../../LicenseCreateInput/typing/loginstate';

import '../style/style.css';

import { cardmargin, grayheader } from '../../CSSReferences';
import { Component } from 'react';
import { licensedata, targetCountFromInput, licenceTiers, catalogModule, modulesFromInput, LicenceTier } from '../typing/types';
import { extrasAfterChange, includedModules, isIncluded, shownTicked, tierChanged, tierLabel } from '../typing/tier';
import { mayRemove, mayRestore } from '../../LicenseTableThingy/typing/licence_rows';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl } from '../../../intl-compat';


export interface LocalProps {
  //defince local porperies (maybe as tag parameter)
  // ONLY TYPES; NO VALUES

  licensedetails: licensedata;
  loadeduuid: string;
  loaded: boolean;
  toleranceDefault: number | null;
  moduleCatalog: catalogModule[];
  // The tier in the select; null while the hub named none.
  selectedTier: LicenceTier | null;
  isAdmin: boolean;
  key: string;
  saveTargetTolerance: (uuid: string, percent: number | null) => void;
  saveTargets: (uuid: string, count: number) => void;
  saveTier: (uuid: string, tier: string) => void;
  saveModules: (uuid: string, names: string[]) => void;
  // FUNCTIONS ALSO INCLUDE
  onSubmit: (data: any, uuid: any) => void;
  deactivateUser: (uuid: string) => void;
  deleteUser: (uuid: string) => void;
  onLoadRequested: (uuid: string) => void;
  requestUserCLientListFromAPI: (uuid: string) => void;
  requestUserNotCLientListFromAPI: (uuid: string) => void;
  requestClientToogle: (uuid: string, useruuid: string, action: string) => void;
  issueEnrollmentCode: (uuid: string) => void;
  removeLicence: (uuid: string) => void;
  restoreLicence: (uuid: string) => void;
  // StartUpload:(uuid:string)=>void;
  onConfigChange: (data: any, type: string) => void;
}


const { Meta } = Card;
//export const UserDetailsView = (props:LocalProps) => {
const MyUserDetailsView = class UserDetailsView extends Component<LocalProps & { intl: any }, {}>
{

  componentDidMount() {
    setTimeout(() => {
      //setInterval(() => {
      this.props.onLoadRequested(this.props.loadeduuid);
      //   this.props.requestUserCLientListFromAPI(this.props.loadeduuid);
      //    this.props.requestUserNotCLientListFromAPI(this.props.loadeduuid);
    }, 200);
  }


  onTabChange(key: string, type: string) {
    console.log(key, type);
    // this.props.setState({ [type]: key });
    //throw new Error('Function not implemented.');
  }

  onChangeUsername = (value: any) => {
    console.log(value.target.value);
    this.props.onConfigChange(value.target.value, "username");
  }
  onChangeName = (value: any) => {
    console.log(value.target.value);
    this.props.onConfigChange(value.target.value, "name");
  }
  onChangeEmail = (value: any) => {
    console.log(value.target.value);
    this.props.onConfigChange(value.target.value, "email");
  }
  onChangeGender = (value: any) => {
    console.log(value.target.value);
    this.props.onConfigChange(value.target.value, "gender");
  }
  onChangeRole = (value: any) => {
    console.log(value.target.value);
    this.props.onConfigChange(value.target.value, "role");
  }
  onChangePassword = (value: any) => {
    console.log(value.target.value);
    this.props.onConfigChange(value.target.value, "password");
  }
  onChangePasswordVerify = (value: any) => {
    console.log(value.target.value);
    this.props.onConfigChange(value.target.value, "passwordverify");
  }

  onChangeTolerance = (value: any) => {
    this.props.onConfigChange(value, "targetTolerance");
  }

  onChangeTargets = (value: any) => {
    this.props.onConfigChange(value, "numberOfTargets");
  }

  onSaveTargets = () => {
    this.props.saveTargets(this.props.loadeduuid, this.props.licensedetails.numberOfTargets);
  }

  onChangeTier = (value: string) => {
    this.props.onConfigChange(value, "tier");
  }

  // Sends the tier only when it differs from the hub's (#9); the button is off otherwise.
  onSaveTier = () => {
    if (this.props.selectedTier !== null && tierChanged(this.props.licensedetails.edition, this.props.selectedTier))
      this.props.saveTier(this.props.loadeduuid, this.props.selectedTier);
  }

  // The modules the tier in the select includes, from the hub's list (#2).
  included = (): string[] =>
    includedModules(this.props.licensedetails.tierFeatures, this.props.selectedTier);

  onChangeModules = (values: any) => {
    this.props.onConfigChange(
      extrasAfterChange(modulesFromInput(values), this.included(), modulesFromInput(this.props.licensedetails.module)),
      "module");
  }

  onSaveModules = () => {
    this.props.saveModules(this.props.loadeduuid, modulesFromInput(this.props.licensedetails.module));
  }

  onSaveTolerance = () => {
    this.props.saveTargetTolerance(this.props.loadeduuid, this.props.licensedetails.targetTolerancePercent ?? null);
  }

  onSubmit = () => {
    console.log("Submit the shit");
    this.props.onSubmit(this.props.licensedetails, this.props.loadeduuid);
  }

  //     props.onLoadRequested(props.loadeduuid)


  callback = (key: any) => {
    console.log(key);
  }

  switchClient = (uuid: any) => {
    console.log('Success:', uuid);
    this.props.requestClientToogle(uuid, this.props.loadeduuid, "activate");
    setTimeout(() => {
      //setInterval(() => {
      this.props.onLoadRequested(this.props.loadeduuid);
    }, 300);
    setTimeout(() => {
      this.props.requestUserCLientListFromAPI(this.props.loadeduuid);
      this.props.requestUserNotCLientListFromAPI(this.props.loadeduuid);
    }, 500);

  };

  removeClient = (uuid: any) => {
    console.log('Success:', uuid);
    this.props.requestClientToogle(uuid, this.props.loadeduuid, "remove");
    setTimeout(() => {
      //setInterval(() => {
      this.props.requestUserCLientListFromAPI(this.props.loadeduuid);
      this.props.requestUserNotCLientListFromAPI(this.props.loadeduuid);
    }, 200);

  };

  addClient = (uuid: any) => {
    console.log('Success:', uuid);
    this.props.requestClientToogle(uuid, this.props.loadeduuid, "add");
    setTimeout(() => {
      //setInterval(() => {
      this.props.requestUserCLientListFromAPI(this.props.loadeduuid);
      this.props.requestUserNotCLientListFromAPI(this.props.loadeduuid);
    }, 200);

  };

  onFinish = (values: any) => {
    console.log('Success:', values);
    this.props.onSubmit(values, this.props.loadeduuid);
  };

  onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };





  render() {
    return (
      <div>
        <Row gutter={16}>
          <Col span={4}>
            <Card
              hoverable
              cover={<img alt={(this.props.intl.formatMessage({ id: "Avatar", defaultMessage: "Avatar" }))} src="/images/catrolling.gif" />}
            >
              <Meta title={this.props.licensedetails.licensedTo}
                description={this.props.licensedetails.archived
                  ? <Tag><FormattedMessage id="License:ArchivedTag" defaultMessage="removed" /></Tag>
                  : ""} />
            </Card>
          </Col>
          <Col span={20}>
            <Card
              hoverable
            >
              <Tabs defaultActiveKey="1" onChange={this.callback}
              items={[
                { key: "1", label: "License Details", children: (<>
                  <Card title={"License Details "} style={cardmargin} hoverable styles={{ header: grayheader }}>
                    <Row gutter={16}>
                      <Col span={8}>
                        <label >License:</label>
                      </Col>
                      <Col span={8}>
                        <input value={this.props.licensedetails.uuid} onChange={this.onChangeName} />
                      </Col>
                      <Col span={8}></Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={8}>
                        <label >Owner:</label>
                      </Col>
                      <Col span={8}>
                        <input value={this.props.licensedetails.licensedTo} onChange={this.onChangeUsername} />
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={8}>
                        <label >Issued:</label>
                      </Col>
                      <Col span={8}>
                        <input value={this.props.licensedetails.signingDate} onChange={this.onChangeEmail} />

                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={8}>
                        <label >Expires:</label>
                      </Col>
                      <Col span={8}>
                        <input value={this.props.licensedetails.expirationDate} onChange={this.onChangeEmail} />
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={8}>
                        <label >number of targets:</label>
                      </Col>
                      <Col span={8}>
                        <InputNumber min={1} precision={0}
                          value={this.props.licensedetails.numberOfTargets || null}
                          onChange={this.onChangeTargets} />
                      </Col>
                      <Col span={8}>
                        <Button onClick={this.onSaveTargets}
                          disabled={targetCountFromInput(this.props.licensedetails.numberOfTargets) === null}>
                          <FormattedMessage id="SaveTargets" defaultMessage="Save number of targets" />
                        </Button>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={8}>
                        <label><FormattedMessage id="TargetTolerance" defaultMessage="Target tolerance (%)" />:</label>
                      </Col>
                      <Col span={8}>
                        {/* Empty = hub default. Signed into the next token the spoke fetches. */}
                        <InputNumber min={0} max={100} precision={0}
                          value={this.props.licensedetails.targetTolerancePercent ?? null}
                          placeholder={tolerancePlaceholder(this.props.intl.formatMessage({ id: "HubDefault", defaultMessage: "default" }), this.props.toleranceDefault)}
                          onChange={this.onChangeTolerance} />
                      </Col>
                      <Col span={8}>
                        <Button onClick={this.onSaveTolerance}>
                          <FormattedMessage id="SaveTargetTolerance" defaultMessage="Save tolerance" />
                        </Button>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={8}>
                        <label><FormattedMessage id="LicenceTier" defaultMessage="Tier" />:</label>
                      </Col>
                      <Col span={8}>
                        {/* Free < Business < Enterprise; ticked modules stay on top. */}
                        <Select style={{ width: 165 }}
                          value={this.props.selectedTier ?? undefined}
                          placeholder={this.props.intl.formatMessage({ id: "License:TierUnknown", defaultMessage: "unknown" })}
                          onChange={this.onChangeTier}
                          options={licenceTiers.map(t => ({ value: t, label: tierLabel(t) }))} />
                      </Col>
                      <Col span={8}>
                        <Button onClick={this.onSaveTier}
                          disabled={!tierChanged(this.props.licensedetails.edition, this.props.selectedTier)}>
                          <FormattedMessage id="SaveLicenceTier" defaultMessage="Save tier" />
                        </Button>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={8}>
                        <label><FormattedMessage id="ExtraModules" defaultMessage="Extra modules" />:</label>
                      </Col>
                      <Col span={8}>
                        {/* On top of the tier; what the tier includes is ticked and fixed. */}
                        <Checkbox.Group
                          value={shownTicked(modulesFromInput(this.props.licensedetails.module), this.included(), this.props.moduleCatalog.map(m => m.name))}
                          onChange={this.onChangeModules}>
                          {this.props.moduleCatalog.map(m => {
                            const inTier = this.props.selectedTier !== null && isIncluded(m.name, this.included());
                            return (
                              <div key={m.uuid}>
                                <Tooltip title={m.description}>
                                  <Checkbox value={m.name} disabled={inTier}>
                                    {m.name}
                                    {inTier && this.props.selectedTier !== null && (
                                      <> {this.props.intl.formatMessage(
                                        { id: "License:IncludedInTier", defaultMessage: "(in {tier} enthalten)" },
                                        { tier: tierLabel(this.props.selectedTier) })}</>
                                    )}
                                  </Checkbox>
                                </Tooltip>
                              </div>
                            );
                          })}
                        </Checkbox.Group>
                      </Col>
                      <Col span={8}>
                        <Button onClick={this.onSaveModules} disabled={this.props.moduleCatalog.length === 0}>
                          <FormattedMessage id="SaveModules" defaultMessage="Save modules" />
                        </Button>
                      </Col>
                    </Row>

                  </Card>
                </>) },
                { key: "3", label: "Client Association", children: (<>

                  {/* <Table columns={this.mandantencolumns} dataSource={this.props.usermandanten} /> 
        <Table columns={this.mandantencolumns2} dataSource={this.props.listmandanten} />  */}

                </>) },
                { key: "5", label: "Spoke enrollment", children: (<>
                  <p>
                    A spoke gets its own hub account by redeeming a one-time code
                    for this licence (valid 7 days). A new code replaces an unused
                    one; enrolling again deactivates the spoke's previous account.
                  </p>
                  <Button type="primary" onClick={() => { this.props.issueEnrollmentCode(this.props.loadeduuid) }}>
                    Issue enrollment code
                  </Button>
                </>) },
                { key: "4", label: "Danger Zone", children: (<>
                  <Row>
                    {/* if (row.active == false){
          return(
          <span style={{"color":"red"}} >[INACTIVE] {row.username} </span>
        );
        }
        else
        {
          return(
            <span style={{"color":"black"}} >{row.username}</span>
          );
        } */}

                    <Button danger onClick={() => { this.props.deactivateUser(this.props.loadeduuid) }} icon={<FontAwesomeIcon icon={["fas", "pause-circle"]} />}>
                      Deactivate
                    </Button>
                  </Row>
                  <Row>
                    {/* Remove = archive on the hub (anima_core #8), admins only. */}
                    {mayRemove(this.props.licensedetails, this.props.isAdmin) && (
                      <Popconfirm
                        title={this.props.intl.formatMessage({ id: "License:RemoveConfirm", defaultMessage: "Remove this licence?" })}
                        description={this.props.intl.formatMessage({ id: "License:RemoveHint", defaultMessage: "The entry is archived, not deleted; the spoke no longer gets a token for it." })}
                        okText={this.props.intl.formatMessage({ id: "License:Remove", defaultMessage: "Entfernen" })}
                        cancelText={this.props.intl.formatMessage({ id: "License:Cancel", defaultMessage: "Cancel" })}
                        onConfirm={() => this.props.removeLicence(this.props.loadeduuid)}
                      >
                        <Button danger icon={<FontAwesomeIcon icon={["fas", "trash-alt"]} />}>
                          <FormattedMessage id="License:Remove" defaultMessage="Entfernen" />
                        </Button>
                      </Popconfirm>
                    )}
                    {mayRestore(this.props.licensedetails, this.props.isAdmin) && (
                      <Button onClick={() => this.props.restoreLicence(this.props.loadeduuid)}>
                        <FormattedMessage id="License:Restore" defaultMessage="Restore" />
                      </Button>
                    )}
                  </Row>
                </>) }
              ]} />
            </Card>
          </Col>
        </Row>

      </div>

    )
  }
};

export default injectIntl(MyUserDetailsView);

